module.exports = __webpack_public_path__ + "img/1-1.976e7221.svg";